import { z } from "zod";

import { InferenceModelSchema } from "../lib/models.model";
import { InstanceLaneSchema } from "../service/instance.models";

export const WorkerInstallTypeSchema = z.enum([
  "Desktop App",
  "Desktop Windows",
  "CLI",
  "Docker",
]);

export const WorkerSchema = z.object({
  _id: z.string(),
  userId: z.string(),
  teamId: z.string(),
  name: z.string(),
  installType: WorkerInstallTypeSchema,
  registrationCode: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
  isArchived: z.boolean().optional(),
  isDisabled: z.boolean().optional(),
  modelOverride: InferenceModelSchema.nullish(),
  laneOverride: InstanceLaneSchema.default("fast").nullish(),
  parallelismOverride: z.number().nullish(),
  engineOverride: z.string().nullish(),
  isApproved: z.boolean(),
  cliVersionOverride: z.string().nullish(),
  inferenceNodeTypeOverride: z.string().nullish(),
});
